import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
    getLotMigratorFormErrorMessage,
    hasLotMigratorFormError
} from '../lot-migrator-form-errors';

@Component({
    selector: 'cb-lot-migrator-pricing-costs-section',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule],
    templateUrl: './lot-migrator-pricing-costs-section.component.html',
    styleUrls: ['./lot-migrator-shared-section.styles.scss']
})
export class LotMigratorPricingCostsSectionComponent {
    @Input({ required: true }) public lotForm!: FormGroup;

    public hasError(controlName: string): boolean {
        return hasLotMigratorFormError(this.lotForm, controlName);
    }

    public getErrorMessage(controlName: string, label: string): string {
        return getLotMigratorFormErrorMessage(this.lotForm, controlName, label);
    }
}
